import React from "react";
import CounterItem from "./counter-item";
import { ifArabic } from "@/utils/language";

export default function CounterOne() {
  const counterData = [
    {
      id: 1,
      count: "100",
      suffix: "%",
      prefix: "",
      duration: 1,
      title: "Employability",
      titleAr: "نسبة التشغيل",
    },
    {
      id: 2,
      count: "33",
      suffix: "%",
      duration: 1,
      title: "Students on Scholarships",
      titleAr: "نسبة الطلبة الحاصلين على منح دراسية",
    },
    {
      id: 3,
      count: "200",
      suffix: "",
      prefix: "+",
      duration: 1,
      title: "Partners",
      titleAr: "شريك من قطاع الصناعة",
    },
    {
      id: 4,
      count: ifArabic("1:18", "18:1"),
      suffix: "",
      duration: 1,
      title: "Students to Faculty",
      titleAr: "نسبة الطلاب إلى أعضاء هيئة التدريس",
    },
  ];
  return (
    <section className="counter-area tp-counter-wrap z-2 position-relative">
      <div className="container">
        <div className="tp-counter-bg wow fadeInUp red-bg" data-wow-delay=".3s">
          <div className="row">
            {counterData.map((item) => (
              <div key={item.id} className="col-lg-3 col-md-6">
                <div className="tp-counter-item text-center">
                  <span className="tp-counter-number">
                    {item.prefix}
                    <CounterItem min={0} max={item.count} />
                    {item.suffix}
                  </span>
                  <p>{ifArabic(item.titleAr, item.title)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
